
export default function FormatedDate(props){
  let days = ["Su", "Mon", "Tue", "wed", "Thu", "Fri", "Sat"];
  let day = days[props.date.getDay()];
  let hours = props.date.getHours();
  // Format hours to ensure two digits
  if (hours < 10) {
    hours = `0${hours}`;
  }
  let minutes = props.date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  // Format and return the full date string
  return `${day} ${hours}:${minutes}`;
}